import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { stateContext } from "../../../states/context";
import BackButton from "../../common/backButton";
import Heading from "../../common/heading";
import ProfileCard from "../../common/profilecard";
import "./style.css";

const ResearchAssistants = () => {
  const { state } = useContext(stateContext);
  const history = useHistory();
  const handleUserRole = (value) => {
    if (value?.id === "semantic_search") {
      history.push("/research/dcs");
    }
    if (value?.id === "text_2_search") {
      history.push("/research/textseeker");
    }
    if (value?.id === "tag_builder") {
      history.push("/research/tagbuilder");
    }

    if (value?.id === "swagger") {
      history.push("/research/swagger");
    }
  };

  return (
    <div className="container h-100">
      <BackButton path={`/`} />
      <div className="main">
        {state?.assistants?.length > 0 ? (
          <>
            <div className="head">
              <Heading />
            </div>
            <div className="login-boxes">
              {state?.assistants
                ?.filter(
                  (_) =>
                    _?.id === "summarizer_assistant" ||
                    _?.id === "semantic_search" ||
                    _?.id === "text_2_search" ||
                    _?.id === "swagger" ||
                    _?.id === "tag_builder"
                )
                ?.map((value, index) => {
                  return (
                    <ProfileCard
                      key={`${index}-profile-chatbot`}
                      img={`${process.env.REACT_APP_BASE_URL}${value?.image_url}`}
                      headText={value?.name || ""}
                      subText={value?.description || ""}
                      onClick={() => handleUserRole(value)}
                    />
                  );
                })}
            </div>
          </>
        ) : (
          <h2>No data found</h2>
        )}
      </div>
    </div>
  );
};

export default ResearchAssistants;
